import { Currency } from '@/core/currency/interfaces';

const SGD: Currency = {
    name: 'Singapore Dollar',
    demonym: 'Singapore',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '702',
    symbol: 'S$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SGD',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default SGD;
